import React from "react";
import { Typography } from "antd";
import ProductRead from "./ProductRead";
import Resolution from "./Resolution";
import QuestionsForm from "./QuestionsForm";
import { useSmartAssistStore } from "../store";
const { Title } = Typography;

export const SmartAssistPhase3 = () => {
  const { selectedIssue, saEvaluatedResolution, saPastResolutionData, isCxUsedProductBefore } = useSmartAssistStore();

  const date = new Date(saPastResolutionData?.date);

  return (
    <>
      <Title level={4} style={{ color: "#1890ff" }}>
        Understand Customer's Usage of {selectedIssue.label}
      </Title>

      {saPastResolutionData?.date && <>
        <span className="text-bg-light">
          <span className="fw-bold">Alert!</span> cx had reported this problem before on {`${date.toLocaleString('default', { month: 'long' })} ${date.getDate().toString()} ${date.getFullYear()}.`}</span>
      </>}

      <div className="mt-3">
        <Resolution data={saPastResolutionData?.resolution?.products} title="Resolution given before:" bgColor="#fbe9e7" />
        <Resolution data={saPastResolutionData?.resolution?.issues} title="Resolution given before:" bgColor="#fbe9e7" />
      </div>

      {isCxUsedProductBefore && <>
        <div>
          <Title level={5}>Questions</Title>
          <QuestionsForm />
        </div>

        <div className="mt-3">
          <Resolution data={saEvaluatedResolution?.products} title="Suggested Resolution:" bgColor="#e3f2fd" />
          <Resolution data={saEvaluatedResolution?.issues} title="Suggested Resolution:" bgColor="#e3f2fd" />
        </div>
      </>

      }
      <ProductRead targetVariantId={selectedIssue.variantId} />
    </>
  )
}

export default SmartAssistPhase3;
